<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destination-google-sheets']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
